import React, { ComponentType, useCallback, useMemo } from "react";
import { connect } from "react-redux";

import { useParams } from "react-router-dom";

import Folder from "@mapmycustomers/shared/types/entity/Folder";
import File from "@mapmycustomers/shared/types/File";
import User from "@mapmycustomers/shared/types/User";

import { IWizardStep, Wizard } from "@app/component/wizard";
import useAnalytics from "@app/util/contexts/useAnalytics";

import { bulkCreateResources } from "../../store/actions";

import styles from "./AddResourcesWizard.module.scss";

export interface AddResourcesWizardState {
  files: File[];
  folderId?: Folder["id"];
  linkName?: string;
  url?: string;
  userIds: User["id"][];
}

interface Props {
  onBulkCreateResources: typeof bulkCreateResources.request;
  onHide: () => void;
  steps: ComponentType<IWizardStep<AddResourcesWizardState>>[];
}

const AddResourcesWizard: React.FC<Props> = ({ onBulkCreateResources, onHide, steps }) => {
  const analytics = useAnalytics();
  const { folderId } = useParams<{ folderId?: string }>();

  const initialState: AddResourcesWizardState = useMemo(
    () => ({
      files: [],
      folderId: folderId ? parseInt(folderId) : undefined,
      userIds: [],
    }),
    [folderId]
  );

  const handleHide = useCallback(() => {
    onHide();
  }, [onHide]);

  const handleFinish = useCallback(
    (state: AddResourcesWizardState) => {
      onBulkCreateResources({
        ...state,
        successCallback: () => {
          analytics.completed(["Add Resource", ...(state.url ? ["Add Link"] : ["Upload File"])]);
          if (state.userIds.length) {
            analytics.completed(["Share Resources"]);
          }
        },
      });
    },
    [analytics, onBulkCreateResources]
  );

  return (
    <Wizard
      className={styles.container}
      initialState={initialState}
      onFinish={handleFinish}
      onHide={handleHide}
      steps={steps}
      width={"40rem"}
    />
  );
};

const mapDispatchToProps = {
  onBulkCreateResources: bulkCreateResources.request,
};

export default connect(null, mapDispatchToProps)(AddResourcesWizard);
